export default "__VITE_ASSET__CP67GXdc__"